var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileWrapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 353.18,
    height: 704.9,
    viewBox: "0 0 353.18 704.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.cls-1{fill:url(#Unbenannter_Verlauf_12);}.cls-2{fill:url(#Unbenannter_Verlauf_12-2);}.cls-3{fill:url(#Unbenannter_Verlauf_12-3);}.cls-4{fill:url(#Unbenannter_Verlauf_12-4);}.cls-5{fill:#1e1e1e;}.cls-6{fill:#010101;}.cls-7{fill:url(#Unbenannter_Verlauf_86);}\n\t\t"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_12",
    x1: 350.57,
    y1: 244.03,
    x2: 350.57,
    y2: 162.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_12-2",
    x1: 1.99,
    y1: 121.9,
    x2: 1.99,
    y2: 94.93,
    xlinkHref: "#Unbenannter_Verlauf_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_12-3",
    x1: 1.99,
    y1: 196.89,
    x2: 1.99,
    y2: 144.88,
    xlinkHref: "#Unbenannter_Verlauf_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_12-4",
    x1: 1.99,
    y1: 260.84,
    x2: 1.99,
    y2: 208.96,
    xlinkHref: "#Unbenannter_Verlauf_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_86",
    x1: 9.31,
    y1: 355.71,
    x2: 358.25,
    y2: 355.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 347.95,
    y: 162.09,
    width: 5.23,
    height: 81.94,
    rx: 2.62,
    ry: 2.62
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 94.93,
    width: 3.98,
    height: 26.97,
    rx: 1.99,
    ry: 1.99
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 144.88,
    width: 3.98,
    height: 52.01,
    rx: 1.99,
    ry: 1.99
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 208.96,
    width: 3.98,
    height: 51.88,
    rx: 1.99,
    ry: 1.99
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 156.05,
    y: 25.14,
    width: 42.2,
    height: 6.39,
    rx: 1.81,
    ry: 1.81
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 214.09,
    cy: 28.15,
    r: 6.39
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.15,17.19H62.42a38,38,0,0,0-38,38V656.24a38,38,0,0,0,38,38H305.15a38,38,0,0,0,38-38v-601A38,38,0,0,0,305.15,17.19Zm31.61,638a32.29,32.29,0,0,1-32.29,32.29H63.09a32.29,32.29,0,0,1-32.28-32.29v-597A32.29,32.29,0,0,1,63.09,25.89H93.87A3.1,3.1,0,0,1,97,29v2.64a18,18,0,0,0,18,18.05h137.9a17.27,17.27,0,0,0,17.27-17.26V28.16a2.27,2.27,0,0,1,2.26-2.27h32a32.29,32.29,0,0,1,32.29,32.29Z",
    transform: "translate(-7.11 -3.26)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M303.42,3.26H64.14A54.83,54.83,0,0,0,9.31,58.1V653.33a54.83,54.83,0,0,0,54.83,54.84H303.42a54.83,54.83,0,0,0,54.83-54.84V58.1A54.83,54.83,0,0,0,303.42,3.26Zm39.73,653a38,38,0,0,1-38,38H62.42a38,38,0,0,1-38-38v-601a38,38,0,0,1,38-38H305.15a38,38,0,0,1,38,38Z",
    transform: "translate(-7.11 -3.26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWrapper);
export default __webpack_public_path__ + "static/media/mobile_wrapper.3f1dda0a776c2da5128f5c0e26b972b9.svg";
export { ForwardRef as ReactComponent };